import React, { useState, useEffect} from 'react';
import '../css/PhoneCallsArea.css';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/joy/List';
import ListDivider from '@mui/joy/ListDivider';
import ListItem from '@mui/joy/ListItem';
import DehazeSharpIcon from '@mui/icons-material/DehazeSharp';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';

import parse from 'html-react-parser'

import {APIGetPhoneCalls} from '../APIS/wupuapAPI.js'
import {calloutcomes} from '../ttpcolumns.js'

import { useSelector } from 'react-redux';

export default function PhoneCallsArea(props) {
    //const [data,setData] = useState(props.data??null)
    const [opennote, setOpenNote] = useState(false)
    const [phonecalls, setPhoneCalls] = useState([])
    const [selnote,setSelNote]=useState(-1)
    const auth = useSelector(state => state.auth)



    useEffect(()=> {
        async function LoadData() {
          if(props.data.uid === null || typeof props.data.uid === 'undefined')
            return
          const ret = await APIGetPhoneCalls({
            token: auth.token,
            ttp_lead_id: props.data.uid,
          })
          if(ret.status)
            setPhoneCalls(ret.data)
        }

        //if(props.data === null && typeof props.data !== 'undefined' && props.data !== null) {
        //  setData(props.data)
        //}

        if(auth.token > "" && typeof props.data !== 'undefined' && props.data.id > "" )
          LoadData();
    },[props.data, auth.token, props.refresh]);

    const handleCloseNote = () => { setOpenNote(false) }

    const handleShowNote = (id) => {
      setSelNote(id)
      setOpenNote(true)
    }


    return (
        <React.Fragment>
        {typeof opennote !== 'undefined' && selnote >= 0 &&
            <Dialog
                open={(opennote && selnote >= 0)}
                onClose={handleCloseNote}
                maxWidth='xl'
                PaperProps={{component: 'form'}}
            >
                <DialogTitle>Phone Call Details</DialogTitle>
                <DialogContent>
                <DialogContentText >Created on: {`${new Date(phonecalls[selnote].datetime_dialled??'').toLocaleString()}`} </DialogContentText>
                <DialogContentText >By: {`${phonecalls[selnote].added_by??''}\r\n\n`}<br/></DialogContentText>
                <DialogContentText >Number Dialled: {`${phonecalls[selnote].number_dialled??''}\r\n`}</DialogContentText>
                <DialogContentText >Call Duration: {`${phonecalls[selnote].call_duration??''} Seconds\r\n`}</DialogContentText>
                <DialogContentText >Callback Set: {`${phonecalls[selnote].callback_set??'No Callback Set'}\r\n`}</DialogContentText><br/>
                Notes from Call
                <div className='postitnote' >
                {parse((phonecalls[selnote].notes??'').replaceAll("\n","<br/>"))}
                </div>
                {/* <TextareaAutosize className='postitnote' maxRows={20} cols={200} rows={20} defaultValue={notes[selnote].note??''} readOnly={true} /> */}
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseNote}>Close</Button>
                </DialogActions>
            </Dialog>
        }
      {props.accordion &&
      <Accordion>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Phone Call History</Typography>
        </AccordionSummary>
        <AccordionDetails>
        <div className='phonecontainer' style={{maxWidth: props.maxwidth??'1280px', width: props.width??'1280px'}}>
            <div className='phonearea' >
                <List variant="outlined" className='phonelist' key='notelist' >
                <ListItem size='sm' key='phonecall_header' >
                    <div className='phone_title' style={{fontWeight: 'bold'}}>Phone No /<br/>Call Duration</div>
                    <div className='phone_date' style={{fontWeight: 'bold'}}>Datetime / Dialled</div>
                    <div className='phone_outcome' style={{fontWeight: 'bold'}}>Call Outcome</div>
                    <div className='phone_text' style={{fontWeight: 'bold'}}>Note / Created By</div>
                    <div className='phone_date' style={{fontWeight: 'bold'}}>Callback</div>
                    <div></div>
                </ListItem>
                <ListDivider inset='gutter' />
                {phonecalls.map( (noteitem,index) => {
                    const lkup = calloutcomes.find(item => item.value === noteitem.call_outcome)
                    let call_outcome = noteitem.call_outcome
                    if(lkup)
                        call_outcome = lkup.label
                    return (<>
                        <ListItem size='sm' key={`notes_${index}`}>
                          <div className='phone_title'  >{`${noteitem.number_dialled}`}<br/>Duration ( {noteitem.call_duration}s )</div>
                          <div className='phone_date' >{`${new Date(noteitem.datetime_dialled?noteitem.datetime_dialled:new Date()).toLocaleString()}`}</div>
                            <div className='phone_outcome'  >{`${call_outcome.substring(0,20).replaceAll('\n',' ')}${call_outcome.length > 20?"...":""}`}</div>
                            <div className='phone_text'  >{`${noteitem.notes.substring(0,125).replaceAll('\n',' ')}${noteitem.notes.length > 125?"...":""}`}<br/>
                            <div className='phone_user' >{`Created by: ${noteitem.added_by??""}`}</div><br/>
                            </div>
                            <div className='phone_date' style={{fontWeight: 'bold'}} >{`${noteitem.callback_set?new Date(noteitem.callback_set).toISOString().substring(0,19).replaceAll("T"," "):'No Call Back'}`}</div>
                            <div><DehazeSharpIcon onClick={() => {handleShowNote(index)}} /></div>
                        </ListItem>
                        <ListDivider inset='gutter' />
                        </>
                    )
                    })
                }
                </List>
            </div>
        </div>
        </AccordionDetails>
        </Accordion>
      }
      {!props.accordion && 
              <div className='phonecontainer' style={{maxWidth: props.maxwidth??'1280px', width: props.width??'1280px', height: '100%'}}>
              <div className='phonearea' style={{height: '100%'}}>
                  <List variant="outlined" className='phonelist' key='notelist' style={{height: '100%'}} sx={{height: '100%'}}>
                  <ListItem size='sm' key='phonecall_header' >
                      <div className='phone_title' style={{fontWeight: 'bold'}}>Phone No /<br/>Call Duration</div>
                      <div className='phone_date' style={{fontWeight: 'bold'}}>Datetime / Dialled</div>
                      <div className='phone_outcome' style={{fontWeight: 'bold'}}>Call Outcome</div>
                      <div className='phone_text' style={{fontWeight: 'bold'}}>Note / Created By</div>
                      <div className='phone_date' style={{fontWeight: 'bold'}}>Callback</div>
                      <div></div>
                  </ListItem>
                  <ListDivider inset='gutter' />
                  {phonecalls.map( (noteitem,index) => {
                      const lkup = calloutcomes.find(item => item.value === noteitem.call_outcome)
                      console.log(lkup)
                      let call_outcome = noteitem.call_outcome
                      if(lkup)
                          call_outcome = lkup.label
                      return (<>
                          <ListItem size='sm' key={`notes_${index}`} >
                            <div className='phone_title'  >{`${noteitem.number_dialled}`}<br/>Duration ( {noteitem.call_duration}s )</div>
                            <div className='phone_date' >{`${new Date(noteitem.datetime_dialled?noteitem.datetime_dialled:new Date()).toLocaleString()}`}</div>
                              <div className='phone_outcome'  >{`${call_outcome.substring(0,20).replaceAll('\n',' ')}${call_outcome.length > 20?"...":""}`}</div>
                              <div className='phone_text'  >{`${noteitem.notes.substring(0,125).replaceAll('\n',' ')}${noteitem.notes.length > 125?"...":""}`}<br/>
                              <div className='phone_user' >{`Created by: ${noteitem.added_by??""}`}</div><br/>
                              </div>
                              <div className='phone_date' style={{fontWeight: 'bold'}} >{`${noteitem.callback_set?new Date(noteitem.callback_set).toISOString().substring(0,19).replaceAll("T"," "):'No Call Back'}`}</div>
                              <div><DehazeSharpIcon onClick={() => {handleShowNote(index)}} /></div>
                          </ListItem>
                          <ListDivider inset='gutter' />
                          </>
                      )
                      })
                  }
                  </List>
              </div>
          </div>
  
      
      }
    </React.Fragment>

    )
}